import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-confirm-popover',
	standalone: true,
	imports: [TranslateModule],
	templateUrl: './confirm-popover.component.html',
	styleUrl: './confirm-popover.component.scss',
})
export class ConfirmPopoverComponent {
	@Input() name: string;
	@Input() popover: NgbPopover;
	@Output() confirm = new EventEmitter();
}
